import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';

const environmentsPage = PageBlueprint.make({
  params: {
    path: '/environments',
    loader: () =>
      import('./EnvironmentsRouter').then(m => <m.EnvironmentsRouter />),
  },
});

export const environmentsPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'environments',
  extensions: [environmentsPage],
});
